import { CardProps } from '@mui/material'
import { RuuviTag } from '../types'
import AlertRuleManagementCard from './AlertRuleManagementCard'

interface RuuviTagAlertRuleManagementCardProps extends Omit<CardProps, 'children'> {
  ruuviTag: RuuviTag
}

export default function RuuviTagAlertRuleManagementCard({
  ruuviTag,
  ...props
}: RuuviTagAlertRuleManagementCardProps) {
  return <AlertRuleManagementCard ruuviTag={ruuviTag} {...props} />
}
